import React from 'react';
import PipeProvider from '../../Services/Providers/PipeProvider';
import StoreListPage from '../../components/Store/Presentation/StoreListPage';
import StoreListPlaceholder from '../../components/Store/Presentation/StoreListPlaceholder';

const StorePage = () => {
  return (
    <PipeProvider
      apiSymbols={['FETCH_STORES']}
      loadingComponent={<StoreListPlaceholder />}
    >
      <StoreListPage />
    </PipeProvider>
  );
};

export default StorePage;
